import { useContext } from 'react';
import dependencyManagerContext from '../dependencyManagerContext';
import * as T from '../types';

const useDependencyManagerContext = (): T.DependencyManagerContextType =>
  useContext(dependencyManagerContext);

export default useDependencyManagerContext;
